import mushodoPromise from '@webapp-next/lib/request/webapp/mushodo-promise';
import { WebappApiResponse } from '@/lib/types/request/request';
import EmployeeType, {
  EmployeeApiTraining,
} from '@/modules/people/types/employee';
import { StateEmploymentEmployeeAgreement } from '@/modules/people/store/employment';
import {
  CustomFieldValues,
  Workplace,
} from '@/modules/people/types/people-setup';

export type EmployeeSave = {
  Id: number;
  FirstName: string;
  LastName: string;
  DisplayName: string;
  Role: number | null;
  Photo: EmployeeType['Photo'];
  WorkplaceIdArray: number[];
  Email: string;
  Mobile: string;
  MainAddressStreet1: string;
  MainAddressCity: string;
  MainAddressCountry?: number;
  MainAddressState?: number;
  MainAddressPostcode: string;
  EmergencyAddressContactName: string;
  EmergencyAddressPhone: string;
  Gender: number | null;
  Pronouns: string | number | null;
  CustomPronouns: string | null;
  DateOfBirth: string | null;
  Position?: string | null;
  Prefers?: number[];
  Manages?: number[];
  sections: string[];
  Agreements?: Partial<StateEmploymentEmployeeAgreement>[] | null;
  Workplaces?: Workplace[] | null;
  StressProfile?: number | null;
  TrainingRecordArray?: EmployeeApiTraining[];
  StartDate?: string | null;
  EmploymentEndDate?: string | null;
  EmploymentEndReason?: string | null;
  EmploymentEndSentiment?: string | null;
  EmploymentEndComment?: string | null;
  PayrollId?: string | null;
  PayCalendarId?: number | null;
  BusinessEntityAccessBusinessNumbers?: string[];

  // enterprise
  LoginSettings?: {
    AllowLogin?: number;
    UserName?: string;
  };
  CustomFieldData?: string | null;
  CustomFieldsData?: {
    id: string;
    apiName: string;
    value: CustomFieldValues;
  }[];
  EntitledLeaveRule?: number[] | null;
};

export default async function employeeSave(
  body: EmployeeSave
): Promise<WebappApiResponse<EmployeeType>> {
  try {
    const { Employee, success, message, data } = await mushodoPromise(
      'ParallelSaveTeamMember',
      body
    );

    if (success) {
      return {
        success: true,
        message: '',
        data: Employee || {},
      };
    } else {
      return {
        success: false,
        message: message || '',
        data: data || {},
      };
    }
  } catch (e) {
    throw e;
  }
}
